<template>
  <div class="mapcontainer h-full">
    <div class="form-panel">
      <j-search-select-tag
        :dictOptions="devOptions"
        @change="selectDev"
        placeholder="搜索设备名称、编号"
        v-model="filter.devId"
      />

      <j-multi-select-tag
        :options="[{
          label: '空闲',
          value: 'free'
        },{
          label: '加水中',
          value: 'busy'
        },{
          label: '故障',
          value: 'alert'
        }]"
        @change="displayMarker"
        style="background: rgb(255, 255, 255); margin-top: 5px; padding: 5px;"
        type="checkbox"
        v-model="filter.runStatus"
      />
    </div>
    <div id="container"></div>

    <device-control-modal ref="devControlModal"></device-control-modal>
  </div>
</template>
  <script>
  import { getAction, postAction } from '@/api/manage'
  import DeviceControlModal from './modules/DeviceControlModal'

  export default {
    name: 'DevListMap',
    components: {
      DeviceControlModal
    },
    data () {
      return {
        map: null,
        filter: {
          runStatus: 'free,busy,alert'
        },
        devices: [],
        devOptions: [],
        devMarkers: [],
        url: {
          list: '/device/devList/list'
        },
      };
    },
    mounted () {
      // 调用
      this.initMap();
    },
    methods: {
      initMap () {
        var that = this;
        //设置一个默认的中心点 (北京市)
        var center = new TMap.LatLng(39.984104, 116.307503)
        //初始化地图
        this.map = new TMap.Map(document.getElementById('container'), {
          center: center,//设置地图中心点坐标
        });
        this.locate();
        //初始化infoWindow
        var infoWindow = new TMap.InfoWindow({
          map: that.map,
          position: new TMap.LatLng(39.984104, 116.307503),
          offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素
        });
        infoWindow.close();//初始关闭信息窗关闭
        this.infoWindow = infoWindow

        //设定marker点及其样式
        this.multiMarker = new TMap.MultiMarker({
          map: this.map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"free"的样式（styles的子属性名即为styleId）
            free: new TMap.MarkerStyle({
              width: 35,  // 点标记样式宽度（像素）
              height: 35, // 点标记样式高度（像素）
              anchor: { x: 17, y: 23 }, // 标注点图片的锚点位置
              src: '/static/image/wf_marker_free.png', // 标注点图片url或base64地址
              color: '#52c41a', // 标注点文本颜色
              size: 16, // 标注点文本文字大小
              direction: 'bottom', // 标注点文本文字相对于标注点图片的方位
              offset: { x: 0, y: 8 }, // 标注点文本文字基于direction方位的偏移属性
              strokeColor: '#fff', // 标注点文本描边颜色
              strokeWidth: 2, // 标注点文本描边宽度
            }),
            busy: new TMap.MarkerStyle({
              width: 35,  // 点标记样式宽度（像素）
              height: 35, // 点标记样式高度（像素）
              anchor: { x: 17, y: 23 }, // 标注点图片的锚点位置
              src: '/static/image/wf_marker_busy.png', // 标注点图片url或base64地址
              color: '#faad14', // 标注点文本颜色
              size: 16, // 标注点文本文字大小
              direction: 'bottom', // 标注点文本文字相对于标注点图片的方位
              offset: { x: 0, y: 8 }, // 标注点文本文字基于direction方位的偏移属性
              strokeColor: '#fff', // 标注点文本描边颜色
              strokeWidth: 2, // 标注点文本描边宽度
            }),
            alert: new TMap.MarkerStyle({
              width: 35,  // 点标记样式宽度（像素）
              height: 35, // 点标记样式高度（像素）
              anchor: { x: 17, y: 23 }, // 标注点图片的锚点位置
              src: '/static/image/wf_marker_alert.png', // 标注点图片url或base64地址
              color: '#9e9e9e', // 标注点文本颜色
              size: 16, // 标注点文本文字大小
              direction: 'bottom', // 标注点文本文字相对于标注点图片的方位
              offset: { x: 0, y: 8 }, // 标注点文本文字基于direction方位的偏移属性
              strokeColor: '#fff', // 标注点文本描边颜色
              strokeWidth: 2, // 标注点文本描边宽度
            }),
            none: new TMap.MarkerStyle({
              src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            }),
          },
          geometries: []
        });

        this.multiMarker.on("click", evt => {
          that.clickMarker(evt.geometry.position, evt.geometry.id)
        })
        //获取设备
        this.getDevList();
      },
      getDevList () {
        getAction(this.url.list, { pageSize: 999999 }).then((res) => {
          if (res.success) {
            this.devices = res.result.records

            const markers = [];
            res.result.records.forEach(device => {
              this.devOptions.push({
                value: device.id,
                text: device.devName
              });
              if (device.coordinateGcj02) {
                const coordinateGcj02 = device.coordinateGcj02.replace('，', ',').split(',');
                markers.push({
                  "id": device.id,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                  "styleId": device.runStatus,  //指定样式id
                  "position": new TMap.LatLng(coordinateGcj02[1], coordinateGcj02[0]),  //点标记坐标位置
                  "properties": {//自定义属性
                    "title": device.devName,
                    "status": device.runStatus,
                  },
                  "content": device.devName,
                });
              }
            });
            this.devMarkers.splice(0, this.devMarkers.length, ...markers);
            this.multiMarker.setGeometries(markers);
          } else {
            this.$message.error(res.message)
          }
        })
      },
      selectDev (id) {
        if (!id) {
          return;
        }
        const that = this;
        this.devMarkers.forEach(marker => {
          if (marker.id === id) {
            if (that.filter.runStatus.includes(marker.properties.status)) {
              that.map.setCenter(marker.position)
              that.clickMarker(marker.position, id)
            } else {
              that.$message.warning('此设备已被隐藏，请勾选设备状态显示')
            }

          }
        });
      },
      clickMarker (position, geometryId) {
        const that = this;
        //设置infoWindow
        this.infoWindow.open(); //打开信息窗
        this.infoWindow.setPosition(position);//设置信息窗位置
        const device = this.devices.find(dev => dev.id === geometryId)
        const pictureObjId = device.pictureObjId;
        const picSrc = pictureObjId ? pictureObjId.split(',')[0] : ''

        let contentHtml = `<div id="infoWindow" class="pop-container">
                <h1 class="pop-title" title="${device.devName}">${device.devName}</h1>
                <p>${device.location}</p>
                <img class="pop-pic" src='${picSrc}' alt="设备照片">
                <span class="pop-tag tag-${device.runStatus}">${device.runStatus_dictText}</span>
                <div class="pop-footer">
                    <div class="pop-btn" data-biz="dev-detail">设备详情</div>
                    <div class="pop-btn" data-biz="dev-control">设备控制</div>
                </div>
            </div>`

        this.infoWindow.setContent(contentHtml);//设置信息窗内容

        const infoWindowDom = document.getElementById('infoWindow');
        infoWindowDom.addEventListener('click', function (evt) {
          if (evt.target.className.includes('pop-btn')) {
            if (evt.target.dataset.biz === 'dev-detail') {
              //设备详情
              that.handleDetail(device)
            } else if (evt.target.dataset.biz === 'dev-control') {
              //设备控制
              that.handleControl(device)
            }
          }
        });
      },
      displayMarker (status) {
        const markers = this.multiMarker.getGeometries();
        markers.forEach(marker => {
          if (!status.includes(marker.properties.status)) {
            marker.styleId = "none";
            marker.content = null;
          } else {
            marker.styleId = marker.properties.status;
            marker.content = marker.properties.title;
          }
        });
        this.multiMarker.updateGeometries(markers)
      },
      handleControl (record) {
        this.$refs.devControlModal.edit({ id: record.id })
        this.$refs.devControlModal.title = `设备控制-【${record.devName}】`
      },
      handleDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.id,
          type: 'drawer'
        })
      },
      locate () {
        var that = this;
        navigator.geolocation.getCurrentPosition(function (position) {
          var latitude = position.coords.latitude;  // 获取纬度
          var longitude = position.coords.longitude;  // 获取经度
          that.map.setCenter(new TMap.LatLng(latitude, longitude))
        });
      },
      locateByIp () {
        //使用定位来获取当前位置调整中心点
        const that = this;
        // 新建一个IP定位类
        const ipLocation = new TMap.service.IPLocation();
        // 未给定ip地址则默认使用请求端的ip地址(params)
        ipLocation.locate({})//发送定位请求获得ip地址
          .then((res) => {
            console.log(res.result.location);
            //将获得的ip地址信息（经纬度）改变地图的中心点
            that.map.setCenter(new TMap.LatLng(res.result.location.lat, res.result.location.lng));
          }).catch((error) => {
            console.log(error);
          });
      }
    }
  }

  </script>
 <style>

  .mapcontainer {
    margin: 0 5px;
    overflow: hidden;
  }

  .form-panel {
    width: 350px;
    position: absolute;
    /* 地图的z-index是1000 */
    z-index: 1001;
    padding: 10px;
  }

  #container {
    width: 100%;
    height: 100%;
  }

  .pop-container {
    width: 250px;
    padding: 5px;
    text-align: left;
  }

  .pop-container p {
    width: 100%;
    text-wrap: wrap;
    word-wrap: break-word;
  }

  .pop-title {
    font-weight: bold;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pop-pic {
    width: 100%;
    margin-bottom: 10px;
  }

  .pop-footer {
    margin-top: 10px;
    text-align: center;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

  .pop-tag {
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    display: inline-block;
    height: auto;
    margin: 0 8px 0 0;
    padding: 2px 10px;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    background: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: default;
    opacity: 1;
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  }

  span.tag-free {
    color: #52c41a;
    background: #f6ffed;
    border-color: #b7eb8f;
  }

  span.tag-busy {
    color: #fa8c16;
    background: #fff7e6;
    border-color: #ffd591;
  }
  span.tag-alert {
    color: #fff;
    background: #9e9e9e;
    border-color: #b8b8b8;
  }

  .pop-btn {
    padding: 5px 10px;
    margin-right: 10px;
    background-color: #007bff;
    color: white;
    text-decoration: none;
    cursor: pointer;
  }

  .pop-btn:hover {
    background-color: #0056b3;
  }

</style>
<style  lang="less" scoped>
  /* antd样式覆盖 */
  /deep/ .ant-drawer {
    z-index: 1001 !important;
  }
</style>